module.exports = __webpack_public_path__ + "img/cooperative1_logo6.3df5c693.jpg";